import { useState } from "react";
import { useNavigate } from "react-router-dom";

const QUESTIONS = {
  weak: {
    label: "Weak AGI",
    description: "Human-level reasoning on specific benchmarks",
    url: "https://www.metaculus.com/questions/3479/date-weakly-general-ai-system-is-devised/",
  },
  strong: {
    label: "Strong AGI",
    description: "Passes comprehensive Turing test",
    url: "https://www.metaculus.com/questions/5121/date-of-artificial-general-intelligence/",
  },
};

const Settings = () => {
  const navigate = useNavigate();
  const [isStrong, setIsStrong] = useState(
    localStorage.getItem("strong-ai") === "true"
  );

  const handleSelect = (strong) => {
    localStorage.setItem("strong-ai", strong);
    setIsStrong(strong);
    navigate("/");
  };

  return (
    <div className="Settings">
      <h1 className="SettingsTitle">Choose AGI Definition</h1>
      <div className="OptionsContainer">
        <div
          className={`OptionCard ${!isStrong ? "OptionCardSelected" : ""}`}
          onClick={() => handleSelect(false)}
        >
          <div className="OptionLabel">{QUESTIONS.weak.label}</div>
          <div className="OptionDesc">{QUESTIONS.weak.description}</div>
          <a
            href={QUESTIONS.weak.url}
            target="_blank"
            rel="noopener noreferrer"
            className="OptionLink"
            onClick={(e) => e.stopPropagation()}
          >
            View on Metaculus
          </a>
        </div>
        <div
          className={`OptionCard ${isStrong ? "OptionCardSelected" : ""}`}
          onClick={() => handleSelect(true)}
        >
          <div className="OptionLabel">{QUESTIONS.strong.label}</div>
          <div className="OptionDesc">{QUESTIONS.strong.description}</div>
          <a
            href={QUESTIONS.strong.url}
            target="_blank"
            rel="noopener noreferrer"
            className="OptionLink"
            onClick={(e) => e.stopPropagation()}
          >
            View on Metaculus
          </a>
        </div>
      </div>
      <button className="BackButton" onClick={() => navigate("/")}>
        Back
      </button>
    </div>
  );
};

export default Settings;
